<!-- eslint-disable vue/no-v-html -->
<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <div class="team-detail-projects-slider-root" v-bind="$attrs">
        <CromaticsDebugSection
      :enabled="debugMode"
      block-class="pimcore-block pimcore-image border rounded p-4 mb-4"
      component-name="TeamDetailProjectsSlider"
      :item="items"
      summary-label="Debug: items JSON"
    />

  	<div class="fullwidth-container-slider">
  		<div class="fullwidth-slider">
  			<div class="swiper-container swiper-content-slider-full-team">
				<div class="swiper-wrapper">
					<div v-for="(item, key) in items" :key="key" class="swiper-slide">
						<div class="container">
							<div class="row g-5 d-flex align-items-center">
								<div
									:class="{
										'col-md-6': item.images.length > 1,
										'col-md-12': item.images.length === 1
									}"
								>
									<div class="fullwidth-container-slider-header">
										<h2 class="mb-5">{{ item.title }}</h2>
									</div>
									<div class="fullwidth-container-text">
										<div v-html="item.text"></div>
									</div>
									<div v-if="item.images.length > 1" class="cta-bottom">
										<div class="cta-social">
											<SocialMedia :contact="contact.Contents[0]" />
										</div>
									</div>
								</div>
								<div
									:class="{
										'col-md-6': item.images.length > 1,
										'col-md-12': item.images.length === 1
									}"
								>
									<div
										class="fullwidth-container-slider-galery row g-3 position-relative"
									>
                                        <CromaticsDebugSection
                      :enabled="debugMode"
                      block-class="pimcore-block pimcore-image border rounded p-4 mb-4"
                      component-name="items"
                      :item="item.images"
                      summary-label="Debug: item.images JSON"
                    />
  								<template v-for="(image, keyimage) in item.images" :key="keyimage">
  									<div
  										v-if="keyimage < 3"
  										:class="{
  											'col-sm-12 large-image': keyimage === 0 && item.images.length !== 1,
  											'col-sm-6 small-image': keyimage > 0,
  											'is-fullimage': keyimage === 0 && item.images.length === 1
  										}"
  									>
  										<NuxtImg
  											:src="completeImageUrl(image?.image?.url || '')"
  											:alt="image?.image?.metadata['alt'] || ''"
                        :title="image?.image?.metadata['title'] || ''"
  											class="w-100"
  											loading="lazy"
                        sizes="1360px"
  										/>
  										<NuxtImg
  											src="/images/logo.gif"
  											width="80"
  											height="80"
  											class="mb-3 swiper-lazy-preloader"
  										/>
  									</div>
  								</template>
									</div>
								</div>
							</div>
							<div
								v-if="item.video"
								class="responsive-video responsive-video--youtube"
							>
								<ScriptYouTubePlayer :video-id="item.video">
									<template #awaitingLoad>
										<div class="position-absolute top-50 start-50 translate-middle" style="height:48px;width:68px;">
											<svg height="100%" width="100%" viewBox="0 0 68 48" version="1.1">
												<path fill="#f00" d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z" />
												<path fill="#fff" d="M 45,24 27,14 27,34" />
											</svg>
										</div>
									</template>
								</ScriptYouTubePlayer>
							</div>
						</div>
					</div>
				</div>
				<div class="swiper-pagination"></div>
				<div class="container-arrows">
					<div v-if="items.length > 1" class="swiper-button-prev">
						<font-awesome-icon :icon="['custom', 'big-arrow-left']" />
					</div>
					<div v-if="items.length > 1" class="swiper-button-next">
						<font-awesome-icon :icon="['custom', 'big-arrow-right']" />
					</div>
				</div>
 		</div>
		</div>
	</div>
</div>
</template>

<script>
import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'
import SocialMedia from './SocialMedia'
import { useIsSmallScreen } from '~/composables/useIsSmallScreen'
import { usePimcoreAssetUrl } from '~/composables/usePimcoreAssetUrl'
export default {
	name: 'TeamDetailProjectsSlider',
	inheritAttrs: false,
	components: {
		SocialMedia
	},
	setup() {
			const { isSmallScreen } = useIsSmallScreen(768)
			// Access runtime config inside setup to avoid calling Nuxt composables outside of setup
			const runtimeConfig = useRuntimeConfig()
			const debugMode = runtimeConfig?.public?.debugMode ?? 0
			return { isSmallScreen, debugMode }
		},
	props: {
		layout: {
			type: Array,
			default: () => []
		},
		items: {
			type: Array,
			required: true,
			default: () => []
		},
		contact: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			activeIndex: 0,
			// Removed legacy resize mixin usage; not needed here
		}
	},
	mounted() {
		this.initSwiper()
		// No-op: legacy resize handling removed
	},
	beforeUnmount() {
		// No-op
	},
	methods: {
		initSwiper() {
			this.$nextTick(() => {
				// eslint-disable-next-line no-unused-vars
				const swiper = new Swiper('.swiper-content-slider-full-team', {
					loop: true,
					lazy: true,
					grabCursor: true,
					spaceBetween: 50,
					slidesPerView: 1,
					autoHeight: false,
					modules: [Navigation, Pagination],
					pagination: {
						el: '.swiper-pagination',
						dynamicBullets: true,
						clickable: true
					},
					breakpoints: {
						1024: {
							navigation: {
								nextEl: '.swiper-button-next',
								prevEl: '.swiper-button-prev'
							}
						}
					}
				})
			})
		},
		completeImageUrl(imagePath) {
			if (!imagePath) {
				return '/images/no-image-placeholder.svg'
			}
			return usePimcoreAssetUrl(imagePath)
		}
	}
}

</script>

<style lang="scss" scoped>
.fullwidth-slider {
	position: relative;
	margin-bottom: 10%;
	background-color: $orange;
	color: $black;
	@include media-breakpoint-up(lg) {
		padding: 10rem 0;
	}
	&.container {
		@include media-breakpoint-down(lg) {
			max-width: 100%;
		}
	}
	@include media-breakpoint-down(lg) {
		max-width: 100%;
	}
	.swiper-button-prev {
		margin-left: 5rem;
	}

	.swiper-button-next {
		margin-right: 5rem;
	}
	.swiper-container {
		width: 100%;
		height: 100%;
		margin: 0;
		padding: 0;
		overflow: hidden;
		position: relative;
		padding-top: 50px;
		display: flex;
		align-items: center;
		@include media-breakpoint-down(lg) {
			padding-top: 20px;
		}
	}

	.swiper-slide {
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
		@include media-breakpoint-down(lg) {
			flex-direction: column-reverse;
			text-align: center;
		}
	}
	.swiper-button-prev,
	.swiper-button-next {
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		width: 60px;
		height: 50px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}

	.swiper-button-prev,
	.swiper-button-next {
		@include font-size(5rem);
		color: $black;
		&::after {
			display: none;
		}
		@include media-breakpoint-down(lg) {
			display: none;
		}
	}
	.swiper-pagination {
		bottom: 0rem;
	}
	.large-image {
		@include media-breakpoint-up(lg) {
			img {
				height: 396px;
				object-fit: cover;
			}
		}
	}
	.small-image {
		@include media-breakpoint-up(lg) {
			img:not(.swiper-lazy-preloader) {
				height: 320px;
				object-fit: cover;
			}
		}
	}
	.contact-social a {
		color: $black !important;
	}
	.cta-bottom {
		margin-top: 5rem;
		display: flex;
		flex-direction: column;
		gap: 30px;
		a {
			color: $black !important;
		}
		.cta-webseite {
			display: flex;
			align-items: center;
			gap: 20px;
			.fa-share {
				width: 30px;
				height: 30px;
				font-size: 25px;
				color: $black !important;
			}
		}
	}
}
.fullwidth-container-slider {
	position: relative;
	left: 50%;
	margin-left: -50vw;
	width: 100vw;
	.container {
		position: relative;
		padding-bottom: 5rem;
	}
}
.container-arrows {
	width: 100%;
	position: absolute;
}
.fullwidth-container-slider-text {
	display: flex;
	align-items: center;
	height: 100%;
	width: 100%;
}
</style>
